import { render, staticRenderFns } from "./RecTextList.vue?vue&type=template&id=4443dcda&scoped=true&"
import script from "./RecTextList.vue?vue&type=script&lang=js&"
export * from "./RecTextList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4443dcda",
  null
  
)

export default component.exports